import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { ApiService } from './api.service';
import { GetOrganizationsQuery, GetOrganizationsQueryVariables, Organization } from '../../../API';
import { GetOrganizations } from '../../../graphql/queries';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ROLE } from '../models/auth';

@Injectable({
  providedIn: 'root',
})
export class UserManagementService {
  public userDetails: any;
  public userRole: string = '';
  public orgList: Organization[] = [];

  constructor(
    private authService: AuthService,
    private apiService: ApiService,
    private nzMessageService: NzMessageService,
  ) {
    this.getUserDetails();
  }

  private getUserDetails() {
    this.userDetails = this.authService.getUserInfo();
    this.userRole = this.authService.getUserRole();

    const excludedRoles = [ROLE.BI_ML_SPECIALIST];
    if (!excludedRoles.includes(this.userRole as ROLE)) {
      this.getOrgList();
    }
  }

  public getBucketName(): string {
    return this.orgList?.find((org) => org?.orgName === this.getOrgType())?.s3Bucket || '';
  }

  public getOrgType(): string {
    return this.userDetails['custom:orgType']?.trim();
  }

  public getOrganizationType(): string {
    return this.orgList?.find((org) => org?.orgName === this.getOrgType())?.orgType || '';
  }

  public getEmail(): string {
    return this.userDetails['email']?.trim();
  }

  public getName(): string {
    return this.userDetails['name']?.trim();
  }

  public getUserRole(): string {
    return this.userRole;
  }

  public getOrgList() {
    this.apiService
      .query<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizations)
      .then((response) => {
        this.orgList = response.data?.GetOrganizations || [];
      })
      .catch((err) => {
        console.warn('Error fetching organization:', err);
        this.nzMessageService.error('Error fetching organization list');
      });
  }

  public isDatabricksConnectionAllowed(): boolean {
    return this.orgList?.find((org) => org?.orgName === this.getOrgType())?.isDatabricksConnectionAllowed || false;
  }
}
